import DashboardPage from "./DashboardPage";

export default [
    {
        path: "/dashboard",
        name: "dashboard",
        component: DashboardPage
    }
]
